var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative","top":"45px","height":"5px"}},[(_vm.show)?_c('v-progress-linear',{staticClass:"ma-0",attrs:{"color":"primary","height":"5","indeterminate":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }